import React from 'react';
import { useFormik } from 'formik';
import fremtindLogo from '@/resources/fremtind.svg';
import '@/styles/main.scss';
import { FormProps, NjffPage, NUMBER_OF_NJFF_FORM_PAGES } from '@/data/Types';
import FormContent from '@/components/FormContent';
import Personvern from '@/components/Personvern';
import { insuranceInitialValues, insuranceValidationSchema } from '@/forms/fields/insurance';

const validationSchema = insuranceValidationSchema();
const initialValues = insuranceInitialValues();

const pageNumber = (page: NjffPage): number => {
    switch (page) {
        case 'personalInfo':
            return 1;
        case 'insurances':
            return 2;
        case 'receipt':
            return 3;
        default:
            return 1;
    }
};

const NjffForm = ({ onSubmit, setPage, page, sentError, removeSentError }: FormProps) => {
    const formik = useFormik({ onSubmit, validationSchema, initialValues });
    return (
        <div className="frame-content">
            <div className="container">
                <div className="logo-and-page-counter-container">
                    <img src={fremtindLogo} height="40" alt="Fremtind logo" />
                    <span className="page-counter">
                        {pageNumber(page)}/{NUMBER_OF_NJFF_FORM_PAGES}
                    </span>
                </div>
                <form className="form-container" onSubmit={formik.handleSubmit}>
                    <FormContent
                        pages={NUMBER_OF_NJFF_FORM_PAGES}
                        setPage={setPage}
                        page={page}
                        formik={formik}
                        sentError={sentError}
                        removeSentError={removeSentError}
                    />
                </form>
                <Personvern />
            </div>
        </div>
    );
};

export default NjffForm;
